export default __webpack_public_path__ + "static/moshe-hitting-rock-fea74a8e2acb57fcce10e2baf9ff7d7f.png";